import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { LocaleProvider } from 'antd';
import { injectGlobal } from 'styled-components';
import enUS from 'antd/lib/locale-provider/en_US';
import createHistory from 'history/createBrowserHistory';
import { UIKitContext } from 'tmt-ui-kit';
import moment from 'moment-timezone';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import createStore from 'utils/createStore';
import theme from 'utils/theme';
import config from 'config';
import 'antd/dist/antd.less';
import 'whatwg-fetch';

const history = createHistory();
const store = createStore(history);

const rootElement = document.getElementById('root');

moment.tz.setDefault('Asia/Bangkok');

/* eslint-disable */
injectGlobal`
  p {
    margin-bottom: 0;
  }
  h1,h2,h3,h4,h5,h6,p,span,ul,li,select,option{font-family:Montserrat!important;}
  h1 {
    font-size: ${theme.fontSize.headline}px;
  }
  h2 {
    font-size: ${theme.fontSize.title}px;
  }
  h3 {
    font-size: ${theme.fontSize.subheader}px;
  }
  p {
    font-size: ${theme.fontSize.body}px;
  }
`;
/* eslint-enable */

ReactDOM.render((
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <LocaleProvider locale={enUS}>
        <UIKitContext
          prefixPath={config.mediaPath}
          prefixAssetPath={config.uiKitAssetPath}
          customTheme={theme}
        >
          <App />
        </UIKitContext>
      </LocaleProvider>
    </ConnectedRouter>
  </Provider>
), rootElement);
registerServiceWorker();

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    ReactDOM.render((
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <LocaleProvider locale={enUS}>
            <UIKitContext
              prefixPath={config.mediaPath}
              prefixAssetPath={config.uiKitAssetPath}
              customTheme={theme}
            >
              <NextApp />
            </UIKitContext>
          </LocaleProvider>
        </ConnectedRouter>
      </Provider>
    ), rootElement);
  });
}



// WEBPACK FOOTER //
// ./src/index.js